<template>
  <b-collapse class="card filters-collapse" :open.sync="showFilters">
    <div slot="trigger" class="card-header filters-trigger">
      <p class="card-header-title">
        {{ $t('filters') }}
      </p>
      <a class="card-header-icon">
        <b-icon pack="fa" v-show="! showFilters" icon="plus-circle"/>
        <b-icon pack="fa" v-show="showFilters" icon="minus-circle"/>
      </a>
    </div>
    <div class="panel" style="border-width: 0">
      <div class="flex flex-col lg:flex-row items-center mb-4">
        <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_name')">
            <b-input
              v-model="filterName"
              :placeholder="$t('name')"
              type="search"
              icon="search"
              icon-pack="fas"
              @input="checkInputTextFilter(filterName)">
            </b-input>
          </b-field>
        </div>

        <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_inspected_status')">
            <b-select ref="input"
                      :placeholder="$t('inspected_status')"
                      v-model="filterCompleted"
                      icon="search"
                      icon-pack="fas"
                      @input="applyFilters(1)"
                      expanded
            >
              <option value="">{{$t('all')}}</option>
              <option value="1">{{$t('completed')}}</option>
              <option value="0">{{$t('uncompleted')}}</option>
            </b-select>
          </b-field>
        </div>
        <div v-if="project.can_progress"
        class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_actual_status')">
            <b-select ref="input"
                      :placeholder="$t('actual_status')"
                      v-model="filterActualCompleted"
                      icon="search"
                      icon-pack="fas"
                      @input="applyFilters(1)"
                      expanded
            >
              <option value="">{{$t('all')}}</option>
              <option value="1">{{$t('completed')}}</option>
              <option value="0">{{$t('uncompleted')}}</option>
            </b-select>
          </b-field>
        </div>
        <!-- El filtro de unidad se oculta solo para tasks (porque usan % por defecto) -->
        <div v-if="type !== 'task'" class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_unit')">
            <b-select ref="input"
                      :placeholder="$t('measurement_unit')"
                      v-model="filterUnitId"
                      icon="search"
                      icon-pack="fas"
                      @input="applyFilters(1)"
                      expanded
            >
              <option value="">{{$t('all')}}</option>
              <option
                v-for="option in unitsList"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>

        <!-- <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_type')">
            <b-select ref="input"
                      v-model="filterType"
                      icon="search"
                      icon-pack="fas"
                      @input="applyFilters(1)"
                      expanded
            >
              <option value="">{{$t('all')}}</option>
              <option value="resource">{{$t('resource')}}</option>
              <option value="task">{{$t('task')}}</option>
            </b-select>
          </b-field>
        </div> -->
        <!-- by activity or sub activity -->

      </div>
      <div class="flex flex-col lg:flex-row items-center mb-4">
        <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_pending_validation')">
            <b-select ref="input"
                      v-model="filterPendingValidation"
                      icon="search"
                      icon-pack="fas"
                      @input="applyFilters(1)"
                      expanded
            >
              <option value="">{{$t('all')}}</option>
              <option value="pending">{{$t('validation_status_pending_validation')}}</option>
              <option v-if="project.has_quality_validation" value="pending_quality">{{$t('validation_status_pending_quality_validation')}}</option>
              <option value="rejected">{{$t('rejected')}}</option>
            </b-select>
          </b-field>
        </div>
        <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_partner')">
            <b-select ref="input"
              :placeholder="$t('partner')"
              v-model="filterPartnerId"
              icon="search"
              icon-pack="fas"
              @input="applyFilters(1)"
              :disabled="project.can_collaborate"
              expanded
            >
              <option value="">{{$t('all')}}</option>
              <option v-for="partner in partners" :key="'partner_'+partner.id" :value="partner.id">
                {{ getDataNamePartner(partner) }}
              </option>
            </b-select>
          </b-field>
        </div>

        <!-- <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_partner_code')">
            <b-input
              v-model="filterPartnerCode"
              :placeholder="$t('partner_code')"
              type="search"
              icon="search"
              icon-pack="fas"
              @input="checkInputTextFilter(filterName)">
            </b-input>
          </b-field>
        </div> -->

        <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_order_number')">
            <b-select ref="input"
              :placeholder="$t('purchase_order')"
              v-model="filterOrderId"
              icon="search"
              icon-pack="fas"
              @input="_HandleInputSelectOrder"
              expanded
            >
              <option value="">{{$t('all')}}</option>
              <option
                v-for="item in ordersList"
                :value="item.id"
                :key="'order_' + item.id">
                {{ item.code }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="w-full lg:w-1/4 mr-4">
          <b-field :label="$t('search_by_position')">
            <b-select ref="input"
              :placeholder="$t('position')"
              v-model="filterPosition"
              icon="search"
              icon-pack="fas"
              @input="applyFilters(1)"
              expanded
              :loading="loadingPositions"
            >
              <option value="">{{$t('all')}}</option>
              <option v-for="item in positionsList" :key="'position_'+item" :value="item">{{ item }}</option>
            </b-select>
          </b-field>
        </div>


      </div>
      <div class="flex flex-col lg:flex-row items-center mb-4">
        <div class="w-full lg:w-1/2 mr-4">
          <b-field :label="$t('search_by_activity')">
            <!-- al hace click en el input que muestre los items  -->
            <b-autocomplete
              v-model="activityName"
              :data="filteredActivities"
              :placeholder="$t('select_activity')"
              field="name"
              @select="onActivitySelect"
              open-on-focus
              icon="search"
              icon-pack="fas"
              @input="onActivityInput"
            >
              <template slot-scope="props">
                <div>{{ props.option.name }}</div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="w-full lg:w-1/2 mr-4">
          <b-field :label="$t('search_by_subactivity')">
            <b-autocomplete
              v-model="subActivityName"
              :data="filteredSubActivities"
              :placeholder="$t('select_subactivity')"
              field="name"
              @select="onSubActivitySelect"
              open-on-focus
              icon="search"
              icon-pack="fas"
              @input="onSubActivityInput"
              :disabled="subActivitiesList.length === 0"
            >
              <template slot-scope="props">
                <div>{{ props.option.name }}</div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
      </div>
      <button class="button is-primary btn-blue" @click="cleanFiltersClicked()">{{$t('clean_filters')}}</button>
    </div>

  </b-collapse>
</template>

<script>
  import axios from "axios";
  import {mapGetters} from "vuex";

  export default {
    name: 'measurement-filters',

    computed: {
      ...mapGetters({
        project: 'app/project',
        company: 'app/company',
      }),

      filteredActivities() {
        let list = this.activitiesList
        if (this.activityName) {
          const search = this.activityName.toLowerCase()
          list = list.filter(act => act.name.toLowerCase().includes(search))
        }
        return [...list].sort((a, b) => a.name.localeCompare(b.name))
      },

      filteredSubActivities() {
        let list = this.subActivitiesList
        if (this.subActivityName) {
          const search = this.subActivityName.toLowerCase()
          list = list.filter(subAct => subAct.name.toLowerCase().includes(search))
        }
        return [...list].sort((a, b) => a.name.localeCompare(b.name))
      },

    },

    components: {},

    props: {
      type: {
        type: String,
        default: 'resource'
      }
    },

    data: () => ({
      showFilters: false,
      unitsList: [],
      partners: [],
      ordersList: [],
      positionsList: [],
      loadingPositions: false,

      filterName: '',
      filterCompleted: null,
      filterActualCompleted: null,
      filterType: null,
      filterSubActivityId: null,
      filterUnitId: null,
      filterPendingValidation: null,
      filterPartnerId: null,
      filterPartnerCode: null,
      filterOrderId: null,
      filterPosition: null,

      activityName: '',
      activityId: null,
      subActivityName: '',
      subActivityId: null,

      activitiesList: [],
      subActivitiesList: [],

    }),

    created() {
      this.getMeasureUnits();
      this.getProjectPartners();
      this.getWorkOrders()
      this.getActivities();
    },

    mounted() {

    },

    watch: {
      activityId: function (newValue) {
        if (newValue) {
          this.subActivitiesList = this.activitiesList.find(activity => activity.id === newValue).children_activities || [];
          this.subActivityId = null;
          this.subActivityName = '';
        } else {
          this.subActivityId = null;
          this.subActivitiesList = [];
        }

        this.applyFilters();
      },

      subActivityId: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.applyFilters();
        }
      },
    },

    methods: {
      async getMeasureUnits() {
        // let data = await axios.get('/api/v2/project/' + this.project.id + '/measurement-units'); // eliminar si todo va bien
        let data = await axios.get('/api/v2/company/' + this.company.id + '/measurement-units');

        if (data.data && data.data.success) {
          this.unitsList = data.data.units;
        }
      },

      async getProjectPartners() {

        const { data } = await axios.get("/api/v2/project/" + this.project.id + "/partners", {'params' : {
          with_orders: 1
        }});

        if (data.data) {
          this.partners = data.data;

          // Colaboradores: preseleccionamos su partner
          if (this.project.can_collaborate && this.project.user_partner_ids && this.project.user_partner_ids.length > 0) {
            const myPartner = this.partners.find(p => this.project.user_partner_ids.includes(p.id));
            if (myPartner) {
              this.filterPartnerId = myPartner.id;
            }
          }

          this.loaded = true
        }

      },

      async getActivities() {
        const { data } = await axios.get('/api/v2/activities/', {params: {
          p: this.project.id,
          tree: 1,
          order_field: 'planning_code',
          order_dir :'asc'
        }});

        if (data.success) {
          this.activitiesList = data.activities;
        } else {
          this.$notify.error("error_loading_data");
        }
      },

      onActivitySelect(selected) {
        this.activityId = selected.id
      },

      onSubActivitySelect(selected) {
        this.subActivityId = selected.id
      },
      onSubActivityInput(value) {
        if (!value) {
          this.subActivityId = null
        }
      },

      onActivityInput(value) {
        if (!value) {
          this.activityId = null
          this.subActivityId = null
          this.activityName = ''
          this.subActivityName = ''
          this.subActivitiesList = []
        }
      },

      async getWorkOrders() {
        const { data } = await axios.get('/api/v2/work-orders', {params: {
          project_id: this.project.id,
          with_partners: 1
        }});

        if (data.success) {
          this.ordersList = data.data
          this.$emit('epc-filter-orders-loaded', this.ordersList)

        } else {
          this.$notify.error("error_loading_data");
        }
      },

      //Fabrica el objeto con los nuevos filtros
      generateFilters() {

        let params = {p: this.project.id, s_num: 1};

        // Filtro por tipo (resource o task) - SIEMPRE incluir el tipo del prop
        if (this.type) {
          params.where_type = this.type;
        }

        // Filtro por nombre
        if (this.filterName.length >= 3) {
          params.like_name = this.filterName
        }

        //Filtro por completado o no
        if (this.filterCompleted != null) {
          params.where_completed = this.filterCompleted
        }

        //Filtro por completado o no
        if (this.filterActualCompleted != null) {
          params.where_actual_completed = this.filterActualCompleted
        }

        //Filtro por unidad de medida - no aplicar para tasks (usan % por defecto)
        if (this.filterUnitId != null && this.type !== 'task') {
          params.where_unit_id = this.filterUnitId
        }


        //Filtro por tipo de asignación - comentado porque ahora usamos el prop type
        // if (this.filterType != null) {
        //   params.where_type = this.filterType
        // }

        if (this.filterPendingValidation != null) {
          params.where_pending_validation = this.filterPendingValidation
        }

        if (this.filterPartnerId != null) {
          params.where_partner_id = this.filterPartnerId
        }

        if (this.filterPartnerCode != null) {
          params.where_partner_code = this.filterPartnerCode
        }

        if (this.filterOrderId != null) {
          params.where_order_id = this.filterOrderId
        }

        if (this.filterPosition != null) {
          params.where_position = this.filterPosition
        }

        if (this.activityId != null) {
          params.where_activity_id = this.activityId
        }

        if (this.subActivityId != null) {
          params.where_sub_activity_id =  this.subActivityId
        }

        return params
      },

      applyFilters() {
        this.$emit('filters-updated', this.generateFilters());
      },

      cleanFiltersClicked() {
        this.filterName = '';
        this.filterCompleted = null;
        this.filterActualCompleted = null;
        this.filterType = null;
        this.filterUnitId = null;
        this.filterPendingValidation = null;
        if (!this.project.can_collaborate) {
          this.filterPartnerId = null;
        }
        this.filterPartnerCode = null;
        this.filterOrderId = null;
        this.filterPosition = null;
        this.isLoadingTable = true;
        this.activityName = '';
        this.activityId = null;
        this.subActivityName = '';
        this.subActivityId = null;
        this.subActivitiesList = [];
        this.applyFilters();
      },

      checkInputTextFilter(filter) {
        if (filter.length >= 3 || filter.length == 0) {
          this.applyFilters(1)
        }
      },

      getDataNamePartner(data) {
        if (data.code)
          return data.code + '    |    ' + data.name

        return data.name
      },

      async _HandleInputSelectOrder(value) {
        this.positionsList = []

        this.applyFilters(1)

        this.loadingPositions = true
        const { data } = await axios.get(`/api/v2/work-orders/${value}/positions`, {params: {}});
        this.loadingPositions = false

        if (data.success) {
          this.positionsList = data.data
        } else {
          console.error('Error loading positions')
          this.$notify.error("error_loading_data");
        }

      }

    },

  };
</script>

<style scoped>
  .filters-collapse {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .filters-trigger:hover {
    background-color: #f8fafc;
  }

  /* FIX TEMPORAL. UN PAQUETE (PROBABLEMENTE @BIMDATA/VIEWER) ESTA SOBREESCRIBIENDO LA CLASE .flex-col */
  @media (min-width: 1024px) {
    .lg\:flex-row {
      flex-direction: row;
    }
  }
</style>
